// Psychologist/useReservationPaid.ts
import {useEffect} from 'react';
import pprint from '../../Utils/pprint';
import {axios} from 'Auth/axiosConfig';
import {useErrorProcessing} from 'Core/components/ErrorProvider';

interface ConsultationData {
    config: any;
    date: string;
}

export function useReservationPaid(reservationPaid: string | null, setValue: Function, setDefaultConsultationConfigId: Function, setDefaultDateTimeSlot: Function) {
    const {byResponse} = useErrorProcessing();

    useEffect(() => {
        const fetchConsultationData = async (consultationId: number) => {
            try {
                const response = await axios.get(`/api/v1/consultations/${consultationId}/`);
                if (response.data) {
                    pprint('Consultation reservation data fetched:', response.data);
                    const {config, date} = response.data as ConsultationData;

                    const existingDataStr = localStorage.getItem('clientRequest');
                    const existingData = existingDataStr ? JSON.parse(existingDataStr) : {};
                    existingData.consultation_config = config;
                    existingData.selected_slot = date;
                    existingData.reservation_paid = consultationId;
                    localStorage.setItem('clientRequest', JSON.stringify(existingData));

                    setValue('consultation_config', config);
                    setValue('selected_slot', date);
                    setDefaultConsultationConfigId(config.id);

                    const readableDate = new Date(date).toLocaleString('ru-RU', {
                        weekday: 'long',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                    });
                    setDefaultDateTimeSlot(readableDate);
                }
            } catch (error) {
                pprint('Ошибка при получении данных консультации:', error);
                byResponse(error);
            }
        };

        if (reservationPaid) {
            const consultationId = parseInt(reservationPaid, 10);
            pprint('consultationId');
            pprint(consultationId);
            if (!isNaN(consultationId)) {
                fetchConsultationData(consultationId);
            } else {
                pprint('Неверный формат reservation_paid:', reservationPaid);
            }
        }
    }, [reservationPaid, setValue, setDefaultConsultationConfigId, setDefaultDateTimeSlot, byResponse]);
}